export const elementConstructionTypeList = [
    {
        text: 'Bovenbouw',
        value: 'superstructure',
        items: [
            { value: '1', text: 'Betonnen dek ingestort in stalen liggers' },
            { value: '2', text: 'Betonnen kokerprofiel (in dwarsrichting, vaak duikers)' },
            { value: '3', text: 'Betonnen kokerligger (lengte richting overspanning)' },
            { value: '4', text: 'In situ gebouwd, traditioneel gewapend' },
            { value: '5', text: 'In situ gebouwd, nagespannen' },
            { value: '6', text: 'Preflex met in situ beton' },
            { value: '7', text: 'Prefab liggers met in situ dek' },
            { value: '8', text: 'Staal; geklonken en gebout, met orthotrope dek' },
            { value: '9', text: 'Staal; Orthotrope; gelast (Bulb profiel of Trog Profiel) Stalen liggers met Orthotroop dek' },
            { value: '10', text: 'Stalen liggers met Orthotroop dek met deuvels' },
            { value: '11', text: 'Stalen balkrooster met houten dek' },
            { value: '12', text: 'Onderdoorgang - beton gewapend/voorgespannen' },
            { value: '13', text: 'Aluminium (Uiverbrug)' },
        ],
    },

    {
        text: 'Onderbouw',
        value: 'substructure',
        items: [
            { value: '14', text: 'Landhoofd - hooggelegen landhoofd' },
            { value: '15', text: 'Landhoofd - L-wand (metselwerk op houten rooster)' },
            { value: '16', text: 'Landhoofd - L-wand (beton)' },
            { value: '17', text: 'Landhoofd - L-wand (metselwerk op betonplaat)' },
            { value: '18', text: 'Landhoofd - combiwand/damwand' },
            { value: '19', text: 'Pijler - metselwerk als gewichtsconstructie' },
            { value: '20', text: 'Pijler - metselwerk boogbrug' },
            { value: '21', text: 'Pijler - staal kolom; geklonken' },
            { value: '22', text: 'Pijler - staal kolom; gelast' },
            { value: '23', text: 'Pijler - staal kolommen met kruisverbanden' },
            { value: '24', text: 'Pijler - staalbetonnen kolom' },
            { value: '25', text: 'Pijler - beton gewapend/voorgespannen' },
            { value: '26', text: 'Onderdoorgang - beton gewapend/voorgespannen' },
            { value: '27', text: 'Kelderpijler -beton gewapend/voorgespannen' },
        ],
    },

    {
        text: 'Fundering',
        value: 'foundation',
        items: [
            { value: '28', text: 'Houten palen met Kespen en Langshout' },
            { value: '29', text: 'Betonnen palen op betonnen funderingsloof' },
            { value: '30', text: 'Betonplaat op houten palen' },
            { value: '31', text: 'Staal' },
        ],
    },
];

export function getConstructionTypeText(id: string) {
    for (const elementGroup of elementConstructionTypeList) {
        for (const constructionType of elementGroup.items) {
            if (constructionType.value === id) {
                return constructionType.text;
            }
        }
    }
    throw new Error(`Unknown constructionType with id "${id}"`);
}
